export const BROWSER_POSITION_WITH_FALLBACK = "BROWSER_POSITION_WITH_FALLBACK"
export const BROWSER_POSITION_WITHOUT_FALLBACK = "BROWSER_POSITION_WITHOUT_FALLBACK"
export const FALLBACK_POSITION = "FALLBACK_POSITION"
export const NO_POSITION = "NO_POSITION"

export const MODES = [BROWSER_POSITION_WITH_FALLBACK, BROWSER_POSITION_WITHOUT_FALLBACK, FALLBACK_POSITION, NO_POSITION]
